'use client'

import { cn } from '@qr-front/ui/utils'
import { ReactNode } from 'react'

import { Link, usePathname } from '@/i18n-routing'

import { TFooterLinkGroup } from './footerLinksData'

export const DesktopLinkGroup = ({
	linkGroup: { title, linkList, url },
	titleIcon,
}: {
	linkGroup: TFooterLinkGroup
	titleIcon?: ReactNode
}) => {
	const currPathname = usePathname()

	return (
		<div className="flex flex-col gap-4">
			{url ? (
				<Link
					href={url}
					className="type-heading-4 inline w-auto max-w-max active:text-blue hover:text-blue"
				>
					{title}
				</Link>
			) : (
				<p className="type-heading-4 flex items-center gap-2">
					{titleIcon || null}
					{title}
				</p>
			)}
			<ul className="flex flex-col gap-4">
				{linkList.map(({ text, url }) => {
					const isActive = url === currPathname

					return (
						<li key={url} className="leading-none">
							<Link
								href={url}
								className={cn(
									'duration-400 type-body-small transition-colors active:text-blue hover:text-blue',
									isActive && 'text-blue',
								)}
							>
								{text}
							</Link>
						</li>
					)
				})}
			</ul>
		</div>
	)
}
